<template>
  <div class="account-verification-page">
    <wallet-header :walletData="walletData" :isLoading="isLoading">
      <template #action-button>
        <button class="btn-universal" disabled>Verify Account</button>
      </template>
    </wallet-header>

    <div class="container">
      <h5 v-if="isLoading">Loading...</h5>
      <div v-else-if="error" class="alert alert-danger">{{ error }}</div>
      <div v-else class="py-5">
        <h2>Account verification</h2>
        <p>Enter your details below to get your account verified</p>

        <form @submit.prevent="handleSubmit">
          <verification-form
            :formData="formData"
            :selectedCountry="selectedCountry"
            :nationalPhoneNumber="nationalPhoneNumber"
            :countries="countries"
            :errors="errors"
            :isPhoneValid="isPhoneValid"
            :phoneInputTouched="phoneInputTouched"
            :isPhoneOTPRequested="isPhoneOTPRequested"
            :isEmailOTPRequested="isEmailOTPRequested"
            :phoneOTPButtonText="phoneOTPButtonText"
            :emailOTPButtonText="emailOTPButtonText"
            :passportFileName="passportFileName"
            :binanceScreenshotFileNames="binanceScreenshotFileNames"
            @update:binance_email="formData.binance_email = $event"
            @update:wallet_address="formData.wallet_address = $event"
            @update:terms_accepted="formData.terms_accepted = $event"
            @update:phone_otp="formData.phone_otp = $event"
            @update:email_otp="formData.email_otp = $event"
            @country-changed="handleCountryChanged"
            @phone-input="handlePhoneInput"
            @request-phone-otp="requestPhoneOTP"
            @request-email-otp="requestEmailOTP"
            @passport-uploaded="handlePassportUpload"
            @binance-screenshots-uploaded="handleBinanceScreenshotsUpload"
            @remove-binance-file="removeBinanceFile"
          />

          <div class="submit-wrapper">
            <button type="submit" :disabled="isSubmitting">
              {{ isSubmitting ? "Submitting..." : "Submit" }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import WalletHeader from "@/components/wallet/WalletHeader.vue";
import VerificationForm from "@/components/wallet/VerificationForm.vue";
import walletMixin from "@/mixins/wallet/walletMixin";
import verificationMixin from "@/mixins/wallet/verificationMixin";

export default {
  name: "AccountVerification",
  components: {
    WalletHeader,
    VerificationForm,
  },
  head: {
    link: [
      {
        rel: "stylesheet",
        href: "/assets/css/wallet.css",
      },
    ],
  },
  mixins: [walletMixin, verificationMixin],
};
</script>
